import { z } from "@core/zod";

import { useZodForm } from "@react/foundation/react-hook-form";

import { useLogEntryActions } from "../../../shared/hooks/useLogEntryActions.ts";

const ManualEntrySchema = z.object(
  { calories: z.number().nonnegative(), name: z.string() },
  {
    calories: "The total kcal of the purchase the entry logs",
    name: "The name of the product the entry logs",
  },
);

interface UseManualEntryFormParams {
  readonly onSaved: () => void;
}

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useManualEntryForm({ onSaved }: UseManualEntryFormParams) {
  const { createLogEntry } = useLogEntryActions();

  return useZodForm({
    defaultValues: { calories: "", name: "" },
    errorMapping: {
      calories: { invalid: "Enter a number." },
      name: { too_small: "Name is required." },
    },
    onSubmit: async values => {
      // oxlint-disable-next-line no-warning-comments
      // TODO(APT-250): create/select a reusable manual product.
      await createLogEntry.mutateAsync({
        name: values.name,
        product: { type: "manual" },
        totalCalories: values.calories,
      });

      onSaved();
    },
    schema: ManualEntrySchema,
    transform: values => {
      return { calories: Number(values.calories), name: values.name.trim() };
    },
  });
}
